module.exports = __webpack_public_path__ + "img/rule56.png";